import { Box, Typography } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styles from "./index.module.css";

export interface IVehicleCheckOverview {
  inProgressBookings: number;
  completed: number;
  pending: number;
}

const VehicleCheckOverviewCard = ({ data }: { data: IVehicleCheckOverview }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleNavigate = (status: "completed" | "pending") => {
    history.push(`/account/vehicles?vehicleCheck=${status}`);
  };

  return (
    <Box className={styles.enhancedCard}>
      <Box className={`${styles.cardContentEnhanced} ${styles.vehicleCheckCard}`}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:vehicleChecks")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #3b82f6, #6366f1)" }}>
            📝
          </Box>
        </Box>

        <Box style={{ marginTop: "6px" }}>
          <Typography
            variant="h2"
            style={{
              fontWeight: 700,
              color: "#1d4ed8",
              fontSize: "32px",
              lineHeight: "1.2",
              marginBottom: "4px",
            }}
          >
            {data.inProgressBookings}
          </Typography>
          <Typography variant="body2" style={{ color: "#64748b", fontSize: "13px" }}>
            {t("root:inProgressBookings")}
          </Typography>
        </Box>

        <Box className={styles.statusList}>
          <Box
            className={`${styles.statusItem} ${styles.statusCompleted}`}
            role="button"
            tabIndex={0}
            onClick={() => handleNavigate("completed")}
            onKeyPress={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                handleNavigate("completed");
              }
            }}
          >
            <Box display="flex" alignItems="center" style={{ gap: "12px" }}>
              <CheckCircleOutlineIcon style={{ color: "#059669" }} />
              <Typography variant="body2" style={{ color: "#0f172a", fontWeight: 600 }}>
                {t("root:vehicleChecksCompleted")}
              </Typography>
            </Box>
            <Typography className={styles.statusMetric}>{data.completed}</Typography>
          </Box>
          <Box
            className={`${styles.statusItem} ${styles.statusPending}`}
            role="button"
            tabIndex={0}
            onClick={() => handleNavigate("pending")}
            onKeyPress={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                handleNavigate("pending");
              }
            }}
          >
            <Box display="flex" alignItems="center" style={{ gap: "12px" }}>
              <ErrorOutlineIcon style={{ color: "#d97706" }} />
              <Typography variant="body2" style={{ color: "#0f172a", fontWeight: 600 }}>
                {t("root:vehicleChecksPending")}
              </Typography>
            </Box>
            <Typography className={styles.statusMetric}>{data.pending}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VehicleCheckOverviewCard;

